/**
 * Buddy TOP splash
 * 黒画面 → ロゴが下からフェードイン → 円マスクで開く
 */
(function () {
  'use strict';

  var html = document.documentElement;
  var splash = document.querySelector('[data-c-top-splash]');
  if (!splash) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var done = false;

  var easeInOutSine = function (t) {
    return -(Math.cos(Math.PI * t) - 1) / 2;
  };

  var animateN = function (from, to, duration, delay) {
    window.setTimeout(function () {
      var start = performance.now();
      var tick = function (now) {
        var p = Math.min(1, (now - start) / duration);
        var n = from + (to - from) * easeInOutSine(p);
        splash.style.setProperty('--n', String(n));
        if (p < 1) window.requestAnimationFrame(tick);
      };
      window.requestAnimationFrame(tick);
    }, delay);
  };

  var hide = function () {
    if (done) return;
    done = true;

    if (reduce) {
      splash.remove();
      html.classList.remove('is-first-loading');
      return;
    }

    splash.classList.add('is-hide');
    animateN(0, 300, 1600, 600);

    window.setTimeout(function () {
      if (splash.parentNode) splash.remove();
      html.classList.remove('is-first-loading');
    }, 1400);
  };

  var start = function () {
    if (reduce) {
      hide();
      return;
    }

    window.setTimeout(function () {
      splash.classList.add('is-logo-in');
    }, 400);

    var minWait = new Promise(function (resolve) {
      window.setTimeout(resolve, 2200);
    });
    var timeout = new Promise(function (resolve) {
      window.setTimeout(resolve, 5000);
    });
    Promise.race([minWait, timeout]).then(hide).catch(hide);
  };

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start, { once: true });
  }
})();
